import { render } from "./Indoors.vue?vue&type=template&id=5a9a4236&scoped=true"
import script from "./Indoors.vue?vue&type=script&lang=js"
export * from "./Indoors.vue?vue&type=script&lang=js"

import "./Indoors.vue?vue&type=style&index=0&id=5a9a4236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9a4236"]])

export default __exports__